var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-5 text-center"},[_c('div',{staticClass:"my-5"},[_vm._v("본인인증에 성공했습니다.")]),_c('mdb-btn',{attrs:{"icon":"check"},on:{"click":_vm.onOk}},[_vm._v(" 확인")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }